import React from "react";
import orangeCheckIcon from "./check-orange.svg";
import whiteCheckIcon from "./check-white.svg";
import { ASSET_PATH } from "../../utilities";
import BookRow from "./table-rows/BookRow";
import UnavailableBookRow from "./table-rows/UnavailableBookRow";

const isInvalidIsbn = (isbn) => {
    const lowerThreshold = 9;
    const upperThreshold = 17;

    return isbn.length < lowerThreshold || isbn.length > upperThreshold;
};

const DisplayBookData = (props) => {
    const existingWishlistIsbns = window.jQuery.fn.watchWishlist().getWishlist()
        ? window.jQuery.fn
              .watchWishlist()
              .getWishlist()
              .isbns.map((book) => book.value)
        : [];
    const selectedIsbns =
        // Only set unique data that isn't already in the wishlist as "selected"
        [
            ...new Set(
                props.bookData
                    .map((bookData) => bookData.isbn)
                    .filter(
                        (bookIsbn) => !existingWishlistIsbns.includes(bookIsbn)
                    )
            ),
        ];

    const onAddToWishlist = () => {
        window.jQuery.fn.watchWishlist().saveBulkIsbn(selectedIsbns);
        window.jQuery.fn
            .notificationManager()
            .sendNotification(
                `${selectedIsbns.length} item${
                    selectedIsbns.length !== 1 ? "s  have" : " has"
                } been added to your list.`
            );
        props.reset();
    };

    return (
        <div className="modal-box-fullsize">
            <div className="display-book-data-directions">
                <p>
                    <b>
                        {selectedIsbns.length} of {props.allIsbns.length} items
                    </b>{" "}
                    can be added to your list.
                </p>
            </div>
            <div className="table-fix-head">
                <table className="modal-table">
                    <thead>
                        <tr>
                            <th colSpan="2" className="col-sm-7 col-lg-8">
                                Title
                            </th>
                            <th>{props.isbnNameSingular}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.allIsbns.map((isbn) => {
                            const matchingBook = props.bookData.find(
                                (bookDatum) => bookDatum.isbn === isbn
                            );
                            const isbnAlreadyInWishList =
                                existingWishlistIsbns.includes(isbn);
                            const multipleCopies =
                                props.bookData.filter(
                                    (bookDatum) => bookDatum.isbn === isbn
                                ).length > 1;

                            if (isInvalidIsbn(isbn) || !matchingBook) {
                                const message = `This is an invalid ${props.isbnNameSingular}. Please check your input and try again. `;
                                return (
                                    <UnavailableBookRow
                                        isbn={isbn}
                                        message={message}
                                    />
                                );
                            } else if (isbnAlreadyInWishList) {
                                const message = `This item already appears in your ${props.wishlistName}.`;
                                return (
                                    <BookRow
                                        matchingBook={matchingBook}
                                        message={message}
                                    />
                                );
                            } else if (multipleCopies) {
                                const message =
                                    "This item is repeated in your list; it will be added once only.";
                                return (
                                    <BookRow
                                        matchingBook={matchingBook}
                                        message={message}
                                    />
                                );
                            } else {
                                return <BookRow matchingBook={matchingBook} />;
                            }
                        })}
                    </tbody>
                </table>
            </div>
            <div className="modal-box-footer">
                <button
                    className="modal-action-btn small-btn back-btn"
                    onClick={props.previousPage}
                >
                    Back
                </button>
                <button
                    className="modal-action-btn right add-to-wishlist"
                    onClick={onAddToWishlist}
                    disabled={selectedIsbns.length === 0}
                >
                    <img
                        src={ASSET_PATH + orangeCheckIcon}
                        alt=""
                        className="right default"
                    />
                    <img
                        src={ASSET_PATH + whiteCheckIcon}
                        alt=""
                        className="right hover"
                    />
                    Add {selectedIsbns.length} item
                    {selectedIsbns.length !== 1 ? "s" : null} to{" "}
                    {props.wishlistName}
                </button>
            </div>
        </div>
    );
};

export default DisplayBookData;



// WEBPACK FOOTER //
// ./src/components/modal-page/DisplayBookData.js